<template>
  <div class="base-form p-0">
    <h2 class="text-center py-2" style="color: black">Orders</h2>
    <div class="dispatch-table-container">
      <b-table
        hover
        no-local-sorting
        small
        :items="data"
        :fields="ordersOptions"
        @row-clicked="onRowClicked"
      >
        <template #cell(info)="row">
          <div
            :id="'order' + row.item.network.name + row.item.id"
            class="dispatch-status"
            :class="statusClass(row.item)"
          />
          <b-tooltip
            :target="'order' + row.item.network.name + row.item.id"
            triggers="hover"
            placement="bottomright"
            custom-class="table-tooltip"
          >
            <div class="text-left">
              <span> <b>Status:</b> {{ row.item.status }} </span><br />
              <span>
                <b>Customer:</b>
                {{
                  row.item.user.first_name + ' ' + row.item.user.last_name
                }}</span
              >
              <br />
              <span> <b>Customer Phone:</b> {{ row.item.user.phone }} </span>
              <br />
              <span> <b>Customer Email:</b> {{ row.item.user.email }} </span
              ><br />
              <span> <b>Network:</b> {{ row.item.network.name }} </span><br />
              <span>
                <b>Address:</b>
                {{ row.item.address | formatAddressStreet }}</span
              >
              <br />
            </div>
          </b-tooltip>
        </template>
        <template #cell(number)="row">
          <router-link :to="`/orders/${row.item.id}`" target="_blank">
            {{ row.item.number }}
          </router-link>
        </template>
        <template #cell(facilityReadyTime)="row">
          {{ row.item.delivery.facility_ready_time | formatDateTimeNoYear }}
        </template>
        <template #cell(facility)="row">
          {{ row.item.facility.name }}
        </template>
      </b-table>
    </div>
    <b-row align-h="between">
      <b-col class="pl-4">
        <p class="table-results my-2">
          Displaying {{ paginationFrom }}-{{ paginationTo }} of
          {{ rows }} results
        </p>
      </b-col>
      <b-col v-if="rows > queryFilters.limit" class="pr-4 mt-2">
        <b-pagination
          v-model="page"
          class="float-right"
          :total-rows="rows"
          :per-page="queryFilters.limit"
          aria-controls="my-table"
          @input="onPaginate"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  data() {
    return {
      data: [],
      rows: 0,
      page: 1,
      paginationFrom: null,
      paginationTo: null,
      queryFilters: {},
      busy: true,

      ordersOptions: [
        {
          key: 'info',
          label: '',
          sortable: false,
          thStyle: { width: '40px' },
        },
        {
          key: 'number',
          label: 'Order ID',
          sortable: false,
          thStyle: { width: '70px' },
        },
        {
          key: 'facilityReadyTime',
          label: 'Facility Ready',
          sortable: false,
          thStyle: { width: '125px' },
        },
        {
          key: 'facility',
          label: 'Hub',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['filters']),
  },
  mounted() {
    this.setStoreFilters();
    this.onPaginate(this.page);
  },
  methods: {
    statusClass(item) {
      if (this.showGrayStatus(item)) {
        return { 'dispatch-status--gray': true };
      }

      return {
        'dispatch-status--green': item.dispatch_status === 2,
        'dispatch-status--yellow': item.dispatch_status === 1,
        'dispatch-status--red': item.dispatch_status === 0,
      };
    },
    setStoreFilters() {
      this.queryFilters = {
        network: this.filters.network ? this.filters.network : null,
        kitchen: this.filters.kitchen ? this.filters.kitchen : null,
        facility: this.filters.hub ? this.filters.hub : null,
        dispatchStatus: this.filters.status ? this.filters.status : null,
        number: this.filters.number ? this.filters.number : null,
        delivery: this.filters.delivery ? this.filters.delivery : null,
        limit: this.filters.limit ? this.filters.limit : 50,
        sort: this.filters.sort ? this.filters.sort : '',
        dir: this.filters.dir ? this.filters.dir : '',
      };

      this.range = {
        ...this.filters.range,
      };
    },
    onPaginate(page) {
      this.page = page;
      this.loadResults();
    },
    onSortingChanged(ctx) {
      this.queryFilters.sort = ctx.sortBy;
      this.queryFilters.dir = ctx.sortDesc ? 'DESC' : 'ASC';
      this.loadResults();
    },
    loadResults() {
      const me = this;

      me.busy = true;

      this.setStoreFilters();

      // Format search params for query
      const searchParams = {
        ...this.queryFilters,
        range: this.range,
        page: this.page,
      };
      searchParams.number = searchParams.number ? searchParams.number : null;
      searchParams.delivery = searchParams.delivery
        ? searchParams.delivery
        : null;
      searchParams.dispatchStatus = searchParams.dispatchStatus
        ? searchParams.dispatchStatus.value
        : null;
      searchParams.fulfillmentCenter = searchParams.kitchen
        ? searchParams.kitchen.id
        : null;
      searchParams.network = searchParams.network
        ? searchParams.network.id
        : null;
      searchParams.facility = searchParams.facility
        ? searchParams.facility.id
        : null;
      searchParams.with = 'delivery,facility,network,address,user';
      searchParams.startDate = me.formatDateFilter(searchParams.range.start);
      searchParams.endDate = me.formatDateFilter(searchParams.range.end);
      searchParams.range = null;
      searchParams.excludeSource = 'zdm-test';

      return ResourceAPI.getRecords('dispatch/orders', searchParams)
        .then((data) => {
          me.rows = data.meta.total;
          me.data = data.data;
          me.paginationFrom = data.meta.from;
          me.paginationTo = data.meta.to;
          me.busy = false;
        })
        .catch((error) => alert(error));
    },

    onRowClicked(record) {
      this.page = 1;
      this.$emit('filterDelivery', record.delivery.id);
    },

    showGrayStatus(item) {
      const showTimeStatuses = [
        'enroute_delivery_expo',
        'delivery_compiling',
        'enroute_dispatch',
        'ready',
        'enroute_customer',
        'completed',
        'refunded',
        'cancelled',
      ];
      return showTimeStatuses.includes(item.status);
    },
  },
};
</script>
